import { RpcDialogOverlayData, RpcDialogOverlayResult } from './rpc-overlay-model';

/**
 * Rpc overlay close sever side handler interface.
 */
export interface RpcOverlayCloseHandler {
    handler(data: RpcDialogOverlayData): Promise<RpcDialogOverlayResult>;
}
